// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"85f53048","97":"2273340b","653":"b7793749","793":"972e7b99","849":"2ca0a2c6","918":"51d268be","941":"9d9b125b"}[chunkId] + ".chunk.js";
};